/* eslint-disable no-console */
import { EAppsFlyerDeepLinkValue } from '@webtrader/core/appsflyer/constants';
import { ALL_MOBILE_ROUTES } from '@webtrader/core/router/mobile';

import { navigationRef } from './navigation';

/**
 * Handle AppsFlyer deep link routing
 * @returns true if routing was performed, false otherwise
 */
export const handleAppsFlyerRoute = (
  deepLinkValue: string | undefined,
  isAuthenticated: boolean,
  hasDemoCreation: boolean,
  isDemo: boolean
): boolean => {
  if (!navigationRef.isReady()) {
    return false;
  }

  try {
    const normalized = deepLinkValue?.toUpperCase();
    switch (normalized) {
      case EAppsFlyerDeepLinkValue.DEMO_SIGNUP_PAGE:
        if (!hasDemoCreation) {
          return false;
        }
        if (isAuthenticated) {
          // eslint-disable-next-line max-depth
          if (!isDemo) {
            navigationRef.navigate(ALL_MOBILE_ROUTES.MAIN.DEMO_CREATION, { publicAuth: false });
          }
        } else {
          navigationRef.navigate(ALL_MOBILE_ROUTES.AUTH.DEMO_CREATION, { publicAuth: true });
        }
        return true;
      case EAppsFlyerDeepLinkValue.HOME:
        if (isAuthenticated) {
          navigationRef.navigate(ALL_MOBILE_ROUTES.MAIN.INDEX, {
            screen: ALL_MOBILE_ROUTES.BOTTOM_TAB.INDEX
          });
        } else {
          navigationRef.navigate(ALL_MOBILE_ROUTES.AUTH.LOGIN);
        }
        return true;
      default:
        return false;
    }
  } catch (e) {
    console.error('APPSFLYER - Deep link navigation failed:', e);
    return false;
  }
};
